module.exports = __webpack_public_path__ + "media/images/logo-horizontal-0b1edbf4523bd52f0b8596a5a61cacfb.png";